import React from "react";
import classes from "./BurgerIngredient.module.css";

function Salad() {
  return <div className={classes.Salad}></div>;
}

export default Salad;
